// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"style__clearfix___3dzd4","content-column":"style__content-column___jyX7h"};


//////////////////
// WEBPACK FOOTER
// ./components/ContentColumn/style.scss
// module id = 1144
// module chunks = 0